<template>
    <section class="blockElement fix-mt">
        <div class="sessionexpriedouter" v-if="$parent.walletSessionTimeOut">
          <div class="cbox">
            <div class="mb-3">
              <img src="./../../../static/website/images/timeOut.svg" alt="session expired" width="100">
            </div>
            <p class="my-4">Your session has expired. Please login again</p>
            <a role="menuitem" class="common_btn" tabindex="-1" href="#" @click.prevent="logout()">login</a>
          </div>
        </div>
        <div class="customFlex-wrapper">
          <app-LeftNavigation></app-LeftNavigation>
			    <div class="rightArea dashboard justify-content-center row vh_100 whiteBG pr-2 pl-0">
            <div class="col-12 p-0">
              <app-header :pageName="pageTitle"></app-header>
              <router-view/>
            </div>
          </div> 
        </div>
    </section>
</template>
<script>
  //import WOW from '../../../static/common/js/wow.min.js'
	import LeftNavigation from './shared/left_navigation'
  import { fxViewMixins } from '@/plugins/fxView'
  import * as types from '../../types'
  import { mapActions } from 'vuex'
  export default {
    name: 'fxViewApp',
    mixins: [fxViewMixins],
    data() {
        return {  
          pageTitle : ''
        }
    },
    components: {    
      appLeftNavigation: LeftNavigation,   
    },
    methods:{
  		groupAdminNameFunc(){
  			this._runGetGroupAdminName({'globalParams' : {} ,'localParams' : {'parameter' : this , 'page' : ''}})
  		},
      ...mapActions({
          _runLogout: types.RUN_USER_LOGOUT
      }),
      logout(){
          const r = this.$router
          this._runLogout({
              router: r,
              parameter: this
          })
      },
    },
  	created(){
      //code pushed
  		this.$store.dispatch(types.RUN_STATE_LOAD)
  		this._runTicketReasonList({'globalParams' : {} ,'localParams' : {'parameter' : this}})
  		this._runGetCountriesList({'globalParams' : {} ,'localParams' : {'parameter' : this}})
      this._runGetNotificationList({'globalParams' : {read: "0"} ,'localParams' : {'parameter' : this}})
  		this.groupAdminNameFunc()
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/website/index.vue